export default "__VITE_ASSET__079d1812__"